import { EDateFormat } from "@/core/@types/types";
import type { IF360Date } from "@/core/plugins/date/F360Date";
import {
  type IDateRange,
  type IShortcutHandler,
  type EShortcutsDate
} from "../../../core/composables/F360DateShortcuts/types";
import { IMapNamesShortcut } from "../types";
import { injectable, inject } from "inversify";
import "reflect-metadata";
import { DITypes } from "@/core/@types/types";

export interface IShortcut {
  initialDate: string | undefined;
  finalDate: string | undefined;
}

@injectable()
export default class Shortcut<T> {
  private filterParams: IShortcut = {
    initialDate: undefined,
    finalDate: undefined
  };

  @inject(DITypes.DATE)
  private libDate!: IF360Date;

  constructor() {
    this.filterParams = {
      initialDate: "",
      finalDate: ""
    };
  }

  getShortcutDate(
    shortcutHandle: EShortcutsDate<T>,
    shortcut: IShortcutHandler<T>
  ): IDateRange | undefined {
    return shortcut.handle(shortcutHandle);
  }

  getShortcutNames(
    arrayNames: IMapNamesShortcut<T>
  ): Map<EShortcutsDate<T>, string> {
    return new Map<EShortcutsDate<T>, string>(arrayNames);
  }

  getCustomShortcutData(shortcut: string[]): IDateRange {
    const customDates: IDateRange = {
      start: "",
      end: "",
      formatedDate: { start: "", end: "" }
    };

    if (!shortcut) return customDates;

    shortcut.forEach((date, index) => {
      const keyDate = index ? "end" : "start";
      customDates[keyDate] = this.libDate.format(
        date,
        EDateFormat.dateParmFormat
      );
      customDates.formatedDate[keyDate] = this.libDate.format(
        date,
        EDateFormat.day
      );
    });

    return customDates;
  }

  handleUpdateShortcut(shortcut: IDateRange) {
    const { start, end } = shortcut;
    this.filterParams.finalDate = end || "";
    this.filterParams.initialDate = start || "";

    return this.filterParams;
  }

  getInicialValues() {
    return Object.assign({}, this.filterParams);
  }
}
